import { Text } from '@change/ds-core-ui/next';

export const text = {
	definition: 'A Decision Maker has the power to create the change you want. If you know who that is, add them now.',
	noneTip: 'Not sure? We’ll find and add the right one when you reach 10 signatures.',
	autoAddedDefinition: 'Great news—we’ve found Decision Makers for your petition!',
	edit: 'You can edit this anytime.',
	autoAddedTip: 'Reaching out now can help you get answers, updates, or a faster response.',
	manualAddedTip: 'Reaching out to Decision Makers now can help you get answers, updates, or a faster response.',
	emailAction: 'A quick email makes a difference.',
	signatureGoal: 'At 100 signatures, we’ll reach out too—because we’re invested in your success.',
	title: 'Contact decision maker',
};

export function DmOverview({
	dmSources,
}: {
	dmSources: 'none' | 'partial_manual_add' | 'only_auto_add' | 'no_email_dms';
}): React.JSX.Element {
	const NoneDm = ({ textDefinition, textTip }: { textDefinition: string; textTip: string }) => (
		<>
			<Text as="p">{textDefinition}</Text>
			<br />
			<Text as="p" fontWeight="bold">
				{textTip}
			</Text>
		</>
	);

	const AutoAddedDm = ({
		textDefinition,
		textTip,
		textEdit,
		textGoal,
	}: {
		textDefinition: string;
		textTip: string;
		textEdit: string;
		textGoal: string;
	}) => (
		<>
			<Text as="p">
				<Text as="strong">{textDefinition}</Text> {textEdit}
			</Text>
			<br />
			<Text as="p">
				{textTip} <Text as="strong">{text.emailAction}</Text>
			</Text>
			<br />
			<Text as="p">{textGoal}</Text>
		</>
	);

	const ManualAddDm = ({
		textTip,
		textAction,
		textGoal,
	}: {
		textTip: string;
		textAction: string;
		textGoal: string;
	}) => (
		<>
			<Text as="p">
				{textTip} <Text as="strong">{textAction}</Text>
			</Text>
			<br />
			<Text as="p">{textGoal}</Text>
		</>
	);

	return (
		<div data-testid="dm-overview">
			<div className="mb-4">
				<Text variant="heading" className="text-size-heading-xs md:text-size-heading-small">
					Reach who matters
				</Text>
			</div>

			<div>
				{dmSources === 'none' && <NoneDm textDefinition={text.definition} textTip={text.noneTip} />}
				{dmSources === 'only_auto_add' && (
					<AutoAddedDm
						textDefinition={text.autoAddedDefinition}
						textTip={text.autoAddedTip}
						textEdit={text.edit}
						textGoal={text.signatureGoal}
					/>
				)}
				{(dmSources === 'partial_manual_add' || dmSources === 'no_email_dms') && (
					<ManualAddDm textTip={text.manualAddedTip} textAction={text.emailAction} textGoal={text.signatureGoal} />
				)}
			</div>
		</div>
	);
}
